import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { unregister } from './serviceWorkerRegistration'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import '../src/Utils/UI/Utils.css'
import { sanitizeHtml } from './Utils/sanitizehtml'

const sanitizeDangerousHtmlProps = (props) => {
    if (
        props?.dangerouslySetInnerHTML &&
        typeof props.dangerouslySetInnerHTML.__html === 'string'
    ) {
        return {
            ...props,
            dangerouslySetInnerHTML: {
                ...props.dangerouslySetInnerHTML,
                __html: sanitizeHtml(props.dangerouslySetInnerHTML.__html),
            },
        }
    }

    return props
}

const wrapElementFactory =
    (factory) =>
    (type, props, ...rest) =>
        factory(type, sanitizeDangerousHtmlProps(props), ...rest)

React.createElement = wrapElementFactory(React.createElement.bind(React))

const store = configureStore()

const jsx = (
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
)

ReactDOM.render(jsx, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorkerRegistration.register()
unregister()
